export const sriConfig = {
  mappings: {
    'https://request.eprotect.vantivcnp.com/eProtect/eProtect-api3.js':
      '/scripts/production-eProtect-api3.js',
    'https://request.eprotect.vantivprelive.com/eProtect/eProtect-api3.js':
      '/scripts/staging-eProtect-api3.js',
  },
  scripts: [
    {
      localFileName: 'production-eProtect-api3.js',
      url: 'https://request.eprotect.vantivcnp.com/eProtect/eProtect-api3.js',
    },
    {
      localFileName: 'staging-eProtect-api3.js',
      url: 'https://request.eprotect.vantivprelive.com/eProtect/eProtect-api3.js',
    },
  ],
}
